













import { Component, Prop, Vue } from "vue-property-decorator";
import { Contact } from "@/types/info.ts";
import SocialIcon from "@/components/SocialIcon.vue";

@Component({
  components: {
    SocialIcon
  }
})
export default class ContactList extends Vue {
  @Prop({ type: Array, required: true }) private contactList!: Contact[];
}
